<template>
    <div class="text-align-center">
        <div style="margin: 15px auto 0; text-aligin: center;color:#6C7D8F;">{{title}}</div>
    </div>
</template>

<script>
  import imgurl from '@/assets/images/figure/search_empty.png'
  export default {
    props: {
      title: {
        default: '暂无数据'
      },
      top: {
        default:115
      }
    },
    data() {
      return {
        noData: imgurl
      }
    },
  };
</script>


